import { appConstants } from '../_constants';

function open(payload) {
    return { type: appConstants.OPEN_MODAL, payload };
}

function close(payload) {
    return { type: appConstants.CLOSE_MODAL, payload };
}
function clear() {
    return {type: appConstants.CLEAR_MODAL};
}

export const modalActions = {
    open,
    close,
    clear
};



// WEBPACK FOOTER //
// ./src/_actions/modal.actions.js